import {
  Button,
  createTheme,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import { RightContainer } from "../../components/RightContainer";
import InputControllerLogin from "../../components/Form/InputControllerLogin";
import { ThemeProvider } from "@emotion/react";
import WhiteInosio from "../../icons/whiteinosio.svg"
interface Props {}

const theme = createTheme({
  components: {
    MuiTypography: {
      variants: [
        {
          props: { id: "company-title" },
          style: {
            fontWeight: "bold",
            fontFamily: "BMW Helvetica 75 !important",
            fontStyle: "normal",
            fontSize: "24px",
            lineHeight: "30px",
            color: "#14142B",
            margin: "0 16px",
          },
        },
        {
          props: { id: "main-text" },
          style: {
            fontWeight: "bold",
            textAlign: "center",
            fontSize: "18px",
            margin: "15px 0",
            width: "80vw",
          },
        },
      ],
    },
  },
});
const useStyles = makeStyles((theme) => ({
  rootContainer: {
    height: "100vh",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    borderRadius: "24px",
  },
  rightContainer: {
    background: "#053742",
    width: "59%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
    height: "100%",
  },
  leftContainer: {
    borderRadius: "24px 0px 0px 24px",
    background: "#ffffff",
    width: "42%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  mainTitle: {
    fontFamily: "BMW Helvetica 75 !important",
    fontStyle: "normal",
    fontSize: "24px !important",
    lineHeight: "30px !important",
    color: "#14142B",
    margin: "0 16px !important",
  },
  forgetpassBox: {
    width: "340px !important",
  },
  forgetpassText: {
    fontSize: "14px !important",
    textAlign: "center",
  },
  sendReqText: {
    color: "rgba(211, 211, 211, 1) !important",
    textDecoration: "none !important",
    padding: " 13px 0 0 10px",
    borderLeft: "3px solid rgba(211, 211, 211, 0.5)",
    height: "35px",
    cursor: "pointer",
    zIndex: 30,
    fontSize: "14px !important",
    width: "27% !important",
  },

  signUpBtn: {
    border: "1px solid #39A2DB !important",
    width: "113px",
    height: "49px",
    borderRadius: "24px !important",
  },
  signUpBtnMobile: {
    border: "1px solid #39A2DB !important",
    width: "100%",
    height: "49px",
    borderRadius: "24px !important",
    marginTop: "270px !important",
  },
  signUpBtnContainer: {
    display: "flex",
    justifyContent: "end",
    width: "350px",
  },
  signUpBtnContainerMobile: {
    display: "flex",
    justifyContent: "end",
    width: "90vw",
  },
  buttonContainer: {
    width: "340px",
    display: "flex",
    flexDirection: "row",
    alignItems: "space-between",
    justifyContent: "space-between",
    marginTop: "20px",
  },
  buttonContainerMobile: {
    width: "90vw",
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "300px",
  },
  SendBtn: {
    background: "#39A2DB !important",
    borderRadius: "24px !important",
    color: "#fff !important",
    width: "128px",
    height: "49px",
  },
  SendBtnMobile: {
    background: "#39A2DB !important",
    borderRadius: "24px !important",
    color: "#fff !important",
    width: "90vw",
    height: "49px",
    marginBottom: "13px !important",
  },
  logInBtn: {
    border: "1px solid #39A2DB !important",
    width: "90px",
    height: "49px",
    borderRadius: "24px !important",
  },
  logInBtnMobile: {
    border: "1px solid #39A2DB !important",
    width: "90vw",
    height: "49px",
    borderRadius: "24px !important",
  },
}));

export const Resend = (props: Props) => {
  const classes = useStyles();

  const matchesMobile = useMediaQuery("(max-width:600px)");
  const matches900 = useMediaQuery("(max-width:900px)");
  const matches1200 = useMediaQuery("(max-width:1200px)");
  return (
    <ThemeProvider theme={theme}>
      <div className={classes.rootContainer}>
        <Grid
          sx={{ flexDirection: "column" }}
          className={classes.leftContainer}
        >
          <Box pb={6} sx={{ display: "flex", alignItems: "center" }}>
            <img src={WhiteInosio} style={{ width: "150px", height: "150px" }} alt="logo" />
          </Box>
          <Typography id="main-text">check your inbox!</Typography>

          <Box className={classes.forgetpassBox}>
            <Typography className={classes.forgetpassText}>
              If you are a registered user, you will receive a password reset
              email. If you need help registering please visit these FAQs (as
              URL).
            </Typography>
          </Box>

          <Box style={{ width: "340px", marginTop: "15px" }}>
            <div style={{ display: "flex" }}>
              <InputControllerLogin
                name={"Email "}
                label={"Email"}
                required={true}
                autoComplete="Email"
                isfullWidth={true}
                type="Email"
              />
            </div>
            <Box
              className={`${
                !matchesMobile
                  ? classes.buttonContainer
                  : classes.buttonContainerMobile
              }`}
            >
              <Button
                href="/login"
                className={`${
                  !matchesMobile ? classes.logInBtn : classes.logInBtnMobile
                }`}
              >
                Log In
              </Button>

              <Button
                href="/changepassword"
                className={`${
                  !matchesMobile ? classes.SendBtn : classes.SendBtnMobile
                }`}
              >
                Send again
              </Button>
            </Box>
          </Box>
        </Grid>

        {!(matches900 && matches1200) ? (
          <Grid className={classes.rightContainer}>
            <RightContainer />
          </Grid>
        ) : (
          <></>
        )}
      </div>
    </ThemeProvider>
  );
};
